var Configurator;
(function (Configurator) {
    __once('.wizard-configuratore', () => {
        const mainWrapperNode = document.querySelector('.webform-submission-configuratore-form');
        const recapDataNode = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('.form--recap');
        const visualRecapDataNode = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('#edit-recap');
        const formNextButton = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('input.webform-button--next');
        const EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        const REQUIRED_INPUTS = 'input[required]';
        function validateEmail(email) {
            if (email.match(EMAIL_REGEX)) {
                return true;
            }
            else {
                return false;
            }
        }
        function setRecapData() {
            if (recapDataNode && visualRecapDataNode) {
                visualRecapDataNode.innerHTML += recapDataNode.innerHTML;
            }
        }
        function checkboxesValidation(checkboxes) {
            checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.forEach(checkbox => {
                if (mainWrapperNode.classList.contains('componenti')) {
                    let validatedFields = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelectorAll(REQUIRED_INPUTS);
                    formNextButton.disabled = Boolean(validatedFields.length);
                    checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.forEach(checkbox => {
                        checkbox.addEventListener('click', (e) => {
                            selectOnlyThis(checkboxes, e.target);
                        });
                    });
                }
                else {
                    let validatedFields = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelectorAll(REQUIRED_INPUTS);
                    formNextButton.disabled = Boolean(validatedFields.length);
                    checkbox.addEventListener('click', (e) => {
                        validatedFields = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelectorAll(REQUIRED_INPUTS);
                        formNextButton.disabled = Boolean(validatedFields.length);
                    });
                }
            });
        }
        function selectOnlyThis(checkboxes, target_checkbox) {
            checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.forEach(checkbox => {
                checkbox.removeAttribute('required');
                checkbox.checked = false;
                formNextButton.disabled = true;
            });
            target_checkbox.checked = true;
            formNextButton.disabled = false;
        }
        function formValidation() {
            const checkboxes = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelectorAll('.form-checkbox');
            checkboxesValidation(checkboxes);
            const emailField = mainWrapperNode === null || mainWrapperNode === void 0 ? void 0 : mainWrapperNode.querySelector('input.form-email');
            if (Boolean(emailField)) {
                formNextButton.disabled = !validateEmail(emailField.value);
                emailField === null || emailField === void 0 ? void 0 : emailField.addEventListener('input', (e) => {
                    formNextButton.disabled = !validateEmail(emailField.value);
                });
            }
        }
        function setActiveLink() {
            const activeSubMenu = document.getElementsByClassName('is-active-submenu');
            if (!activeSubMenu)
                throw new Error();
            if (activeSubMenu.length > 0) {
                const trailMenu = activeSubMenu[0].closest('.nav-main-item.has-submenu').getElementsByClassName('nav-main-link');
                trailMenu[0].classList.add('is-active');
            }
        }
        function init() {
            if (mainWrapperNode) {
                formValidation();
                setRecapData();
                setActiveLink();
            }
        }
        init();
    });
})(Configurator || (Configurator = {}));
